import type { MemoryDTO } from "../../shared/types";

/**
 * Who last changed a memory, said only when that is news: the person who changed it, or an agent other than the one
 * that wrote it. Null for a memory never changed since it was recorded, or changed only by its own writer's agent.
 * The same rule as `pandas memory` in bin/pandas.
 */
export function changedBy(m: MemoryDTO): string | null {
  if (m.updatedByUserName) return m.updatedByUserName;
  return m.updatedByAgentSlug && m.updatedByAgentSlug !== m.authorAgentSlug ? m.updatedByAgentSlug : null;
}
